import { extractOnlyNumbers, parseOnlyNumericValue, removeMultipleSpace, safeToString, sliceText } from "../../../utils/common";

const today = new Date().toISOString().split('T')[0];
const houndredYearsAgo = new Date();
houndredYearsAgo.setFullYear(houndredYearsAgo.getFullYear() - 100);
const minDate = houndredYearsAgo.toISOString().split('T')[0];
const stateOptions = [
  { value: 1, label: 'Uttarakhand' },
  { value:2, label: 'West Bengal' },
];

export const ESI_INITIAL_STATE={
  employer_contribution:3.25,
  employee_contribution:0.75,
  country:1,
  isDisableEsi:false,

  "is_esi": false,
  "esi_code": "",
  "coverage_date": "",
  "esi_office": "",
  "address": "",
  "city": "",
  "state": null,
  "pincode": "",
  "location": "",
  "is_including_employee_ctc": false

}
export const ESI_INPUT_FIELDS = {
  is_esi: {
    name: "is_esi",
    label: "ESI",
    type: "checkbox",
    fullWidth: true,
  },
  esi_code: {
    name: "esi_code",
    label: "ESI Code",
    placeholder: "Type Here...",
    type: "text",
    fullWidth: true,
 
    required:true,
customOptions:

{
  formatValueFn:(value)=>{  
     return sliceText(extractOnlyNumbers(value),17);
   }

}
  },
  coverage_date: {
    name: "coverage_date",
    label: "Coverage Date",
    type: "date",
    placeholder: "Type Here...",
    fullWidth: true,
    required:true,
    max:today,
  

min:minDate,
  },
  employee_contribution: {
    name: "employee_contribution",
    label: "Employee Contribution",
    type: "text",
    placeholder: "Type Here...",
    prefix: "%",
    fullWidth: true,
    required:true,
    value:"0.75",
    disabled:true,

  },
  employer_contribution: {
    name: "employer_contribution",
    label: "Employer Contribution",
    type: "text",
    placeholder: "Type Here...",
    prefix: "%",
    fullWidth: true,
    required:true,
      value:"3.25",
  
    disabled :true,
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(removeMultipleSpace(safeToString(value)),150);
       return value;
     }
      
      }

  },
  esi_office: {
    name: "esi_office",
    label: "ESI Office",
    placeholder: "Type Here...",
    type: "text",
    fullWidth: true,
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(removeMultipleSpace(safeToString(value)),150);
       return value;
     }
      
      }

  },
  address: {
    name: "address",
    label: "Address",
    placeholder: "Type Here...",
    type: "text",
    fullWidth: true,
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(removeMultipleSpace(safeToString(value)),150);
       return value;
     }
      
      }

  },
  city: {
    name: "city",
    label: "City",
    placeholder: "Type Here...",
    type: "text",
    fullWidth: true,
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(removeMultipleSpace(safeToString(value)),150);
       return value;
     }
      
      }

  },
  state: {
    name: "state",
    label: "State",
    type: "select", // Assuming state is represented by an ID
    placeholder: "Enter State Code...",
    fullWidth: true,
    options:stateOptions,
  },
  country: {
    name: "country",
    label: "Country",
    placeholder: "Type Here...",
    type: "select",
    fullWidth: true,
    disabled:true,
    options:[
      { id: 1, name: "India" }
    ]
  },
  pincode: {
    name: "pincode",
    label: "Pincode",
    placeholder: "Type Here...",
    type: "text",

    fullWidth: true,
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(parseOnlyNumericValue(safeToString(value)),6);
       return value;
     }
      
      }

  },
  location: {
    name: "location",
    label: "Location",
    placeholder: "Type Here...",
    type: "text",
    fullWidth: true,
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(removeMultipleSpace(safeToString(value)),150);
       return value;
     }
      
      }

  },
  is_including_employee_ctc: {
    name: "is_including_employee_ctc",
    // label: "Including in Employee CTC",
    type: "checkbox",
    // fullWidth: true,
    required:true,

  },
};


export const ESI_API={
  ESI_CREATE:{URL:"/organization-statutory/esi/", METHOD:"POST"},
  ESI_UPDATE:{URL:"/organization-statutory/esi/", METHOD:"PATCH"},
  ESI_DELETE:{URL:"/organization-statutory/esi/", METHOD:"DELETE"},
  ESI_LIST:{URL:"/organization-statutory/esi/", METHOD:"GET"},
  MASTER_ESI_LIST:{URL:"/organization-statutory/esi/admin/master", METHOD:"GET"},
  
  };
